import { getSettingDefinitions } from "../api/settings/getSettingDefinitions";
import { CvpSettings } from "./CvpSettings";

export function getDefaultSettings(iframe: boolean): CvpSettings {
  return Object.entries(getSettingDefinitions(iframe)).reduce(
    (acc, [settingName, definition]) => {
      acc[settingName] = definition.defaultValue;
      return acc;
    },
    {} as CvpSettings
  );
}
